import {
  COMMISSION_ROUTES,
  commissionParamsResponseSchema,
  type CommissionParams,
  type CommissionParamsUpdate,
} from "@nh/shared";
import { authFetch } from "@/shared/api/session";

/** Los parámetros del plan: leerlos y ajustarlos. Solo super-admin. */
const NO_PREFIX = { baseUrl: "" } as const;

export async function getCommissionParams(): Promise<CommissionParams> {
  const data = await authFetch(
    COMMISSION_ROUTES.adminParams,
    commissionParamsResponseSchema,
    NO_PREFIX,
  );
  return data.params;
}

export async function updateCommissionParams(
  update: CommissionParamsUpdate,
): Promise<CommissionParams> {
  const data = await authFetch(COMMISSION_ROUTES.adminParams, commissionParamsResponseSchema, {
    ...NO_PREFIX,
    method: "PATCH",
    body: update,
  });
  return data.params;
}
